import { alpha, styled } from '@mui/material';
import { VersionMetadata } from 'api/model';
import useDialog from 'hooks/useDialog';
import VersionDialog from './VersionDialog';
import { FONT_MONO } from 'themes/tokens';

type VersionChipProps = {
  type: 'UI' | 'API';
  metadata: VersionMetadata;
};

const VersionPill = styled('button')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  padding: theme.spacing(0.5, 1.25, 0.5, 0.5),
  borderRadius: '999px',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  fontFamily: FONT_MONO,
  fontSize: '0.78rem',
  fontWeight: 700,
  color: theme.palette.info.main,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['background-color', 'border-color']),
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.16),
  },
  '& .version-type': {
    display: 'inline-grid',
    placeItems: 'center',
    padding: theme.spacing(0.375, 0.875),
    borderRadius: '999px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: '0.62rem',
    fontWeight: 700,
    letterSpacing: '0.06em',
  },
}));

const VersionChip = ({ metadata, type }: VersionChipProps) => {
  const [showVersionDetails, VersionDetailsDialog] = useDialog(VersionDialog);
  const label = metadata.version && metadata.version !== '' ? metadata.version : (metadata.branch ?? 'unknown');

  return (
    <>
      <VersionPill type="button" onClick={() => showVersionDetails(true)} aria-label={`${type} version ${label}`}>
        <span className="version-type">{type}</span>
        {label}
      </VersionPill>
      <VersionDetailsDialog versionMetadata={metadata} onClose={() => showVersionDetails(false)} />
    </>
  );
};

export default VersionChip;
